import React, { useState } from "react";
import { ArrowsLeftRight, TrendUp } from "@phosphor-icons/react";
import { useRate } from "../context/RateContext";
import { useT } from "../i18n";
import { formatMAD, formatEUR } from "../lib/format";
import { Input } from "./ui/input";

const CurrencyConverter = () => {
  const rate = useRate();
  const { t } = useT();
  const [amount, setAmount] = useState(100000);
  const [madToEur, setMadToEur] = useState(true);

  const result = madToEur ? amount * rate.mad_to_eur : amount * rate.eur_to_mad;
  const fromCur = madToEur ? "MAD" : "EUR";
  const toCur = madToEur ? "EUR" : "MAD";

  return (
    <div data-testid="currency-converter" className="bg-white border border-navy/10 rounded-2xl p-6 sm:p-8">
      <div className="flex items-center gap-2 text-sm text-gold font-semibold mb-5">
        <TrendUp size={20} weight="light" />
        1 € ≈ {rate.eur_to_mad?.toFixed?.(3)} MAD · 1 MAD ≈ {rate.mad_to_eur?.toFixed?.(4)} €
        <span className="text-xs text-muted-foreground font-normal">{t("conv.note")}</span>
      </div>

      <div className="grid grid-cols-[1fr_auto_1fr] items-end gap-3">
        <div>
          <label className="text-xs text-muted-foreground block mb-1.5">{fromCur}</label>
          <Input data-testid="converter-input" type="number" value={amount} onChange={(e) => setAmount(Number(e.target.value) || 0)} className="h-12 text-lg font-display" />
        </div>
        <button data-testid="converter-swap" onClick={() => setMadToEur((v) => !v)} className="w-11 h-12 flex items-center justify-center bg-navy text-white rounded-xl hover:bg-[#254B75] transition-colors">
          <ArrowsLeftRight size={20} />
        </button>
        <div>
          <label className="text-xs text-muted-foreground block mb-1.5">{toCur}</label>
          <div data-testid="converter-result" className="h-12 flex items-center px-3 bg-background border border-navy/10 rounded-md font-display text-lg text-navy">
            {toCur === "EUR" ? formatEUR(result) : formatMAD(result)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyConverter;
